import './CondensedBundleCard.scss'
import classnames from 'classnames'
import { CuiMenuImage, CuiTag } from 'front-lib'
import { CardTitle } from 'src/componentsV2/MenuMealCard/components/CardTitle/CardTitle'
import { ChefsRow } from '../../ChefsRow/ChefsRow'
import { AddButton } from 'src/componentsV2/MenuMealCard/components/AddButton/AddButton'
import {
  bundleStrikethroughPrice,
  getBundleAddButtonText,
  getChefs,
  getMainTags
} from '../utils'
import { isAddOn } from '../../../modules/MyPlan/utils'
import { getBundleCharacteristicsFromMeals } from 'src/componentsV2/MenuMealCard/utils'
import { CharacteristicsL1 } from 'src/componentsV2/MenuMealCard/components/CharacteristicsL1/CharacteristicsL1'
import { useBoxOrderingModel } from 'src/hooks/useBoxOrderingModel'

export const CondensedBundleCard = ({
  bundle,
  isEditable,
  stock,
  quantity,
  onBundleClick,
  onAddItem,
  onRemoveItem,
  planIsCompleted,
  noExtraMealPlanIsCompleted = false
}) => {
  const outOfStock = isEditable && stock <= 0
  const mainTags = getMainTags(bundle, 2)
  const showActions = isEditable && !outOfStock
  const strikethroughPrice = bundleStrikethroughPrice(bundle, planIsCompleted)

  const chefsList = getChefs(bundle)
  const isExtra = isAddOn(bundle)
  const { isBOM } = useBoxOrderingModel()

  const noExtraMealPlanStatus =
    !noExtraMealPlanIsCompleted || (noExtraMealPlanIsCompleted && quantity > 0)

  const noExtraMealPlanStatusWithExtra =
    !noExtraMealPlanIsCompleted || (noExtraMealPlanIsCompleted && isExtra)

  const characteristics = getBundleCharacteristicsFromMeals(bundle)

  return (
    <div
      className={classnames('bundle-card-condensed', {
        'bundle-card-condensed-sold-out': outOfStock
      })}
      onClick={onBundleClick}>
      <CuiMenuImage
        primary_image={bundle.primaryImageUrl || bundle.image}
        className="bundle-card-condensed-img"
      />
      <div className="bundle-card-condensed-details">
        <div className="bundle-card-condensed-row bundle-card-condensed-start">
          <div className="bundle-card-condensed-column">
            <div className="bundle-card-condensed-tags-wrapper">
              {mainTags.map(tag => (
                <CuiTag
                  color={tag.color}
                  fill="solid"
                  size="small"
                  className={classnames('bundle-card-condensed-tag', {
                    'bundle-card-condensed-tag-with-icon': !!tag.icon
                  })}>
                  {tag.icon}
                  {tag.label}
                </CuiTag>
              ))}
            </div>

            <div className="bundle-card-condensed-details-title">
              <CardTitle
                title={bundle.name}
                subtitle={bundle.subtitle}
                onClick={() => {}}
                size="small"
              />
              <ChefsRow
                size={'small'}
                chefs={chefsList}
                colorText="dark"
                entityType={bundle.entityType}
              />
            </div>
          </div>
        </div>
        <div className="bundle-card-condensed-details-line">
          <CharacteristicsL1
            list={characteristics}
            mealId={bundle.inventoryId}
            size="small"
          />
          <span className="bundle-card-condensed-products-text">
            {bundle.meals ? bundle.meals.length : bundle.items.length} products
          </span>
        </div>
        {showActions && (isExtra || noExtraMealPlanStatus) && (
          <div
            onClick={e => e.stopPropagation()}
            className="bundle-card-condensed-row bundle-card-condensed-row-end">
            <div
              className={classnames('bundle-card-condensed-details-price', {
                '-has-fee': noExtraMealPlanStatusWithExtra && true
                // TODO replace (meal.premium_fee > 0 || isExtra) && !strikethroughPrice
              })}>
              <span className="bundle-card-condensed-details-price-text">
                {getBundleAddButtonText(
                  bundle,
                  planIsCompleted,
                  isExtra,
                  noExtraMealPlanIsCompleted,
                  isBOM
                )}
              </span>
              {!!strikethroughPrice && (
                <span className="strikethrough-price-text">
                  {strikethroughPrice}
                </span>
              )}
            </div>
            <AddButton
              quantity={quantity}
              add={() => onAddItem(bundle)}
              remove={() => onRemoveItem(bundle)}
              addEnabled={quantity < stock && noExtraMealPlanStatusWithExtra}
            />
          </div>
        )}
        {outOfStock && <div className="card-condensed__sold-out">SOLD OUT</div>}
      </div>
    </div>
  )
}
